import { useContext } from 'react'

import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/usePricingPlan'
import usePricingPlans from '@hooks/usePricingPlans'

import ListBlankState from '@components/ListBlankState'
import PageHeader from '@components/PageHeader'

import PageContext from '@contexts/pageContext'

import PricePlanListItem from '../PricingPlanListItem'

const PageContent = () => {
  const pricingPlansPayload = usePricingPlans({ performHttpRequests: true })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPricingPlans,
    filteredPricingPlansCount,
    hasFilteredPricingPlans,
    loading,
  } = pricingPlansPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      showCreateOrEditPricingPlanModal,
    },
  } = pageContext

  const { pricingPlansIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Pricing Plans | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => showCreateOrEditPricingPlanModal()} size="medium">
            Create
          </Button>
        )}
        activeTabBarItemKey="pricingPlans"
        tabBarItems={[
          {
            href: pricingPlansIndexUrl,
            icon: faGlobe,
            key: 'pricingPlans',
            title: 'Pricing Plans',
          },
        ]}
        title="Pricing Plans"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredPricingPlans && <ListBlankState />}

            {!loading && hasFilteredPricingPlans && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Pricing Plans">
                <Box flexDirection="column">
                  {filteredPricingPlans.map(pricingPlan => (
                    <PricePlanListItem key={pricingPlan.id} pricingPlan={pricingPlan} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredPricingPlansCount}
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
